import script from "./BaseLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLayer.vue?vue&type=script&setup=true&lang=js"

import "./BaseLayer.vue?vue&type=style&index=0&id=70baf19e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70baf19e"]])

export default __exports__